import * as types from './types'
import {
  makeAsyncAction,
  makeForbidAsyncAction,
  makeAsyncRestfulAction,
} from './vuex-utils'
const wx = require('weixin-js-sdk');
import { get } from '@/utils/request'

export default {
  [types.APPLY_IDENTITY]: makeAsyncAction('/player/api/v4/identity/apply', null, "post"),
  [types.GET_IDENTITY]: makeAsyncAction('/api/v1/identity/:id', null, "get"),
  [types.PAY]: makeForbidAsyncAction('/api/v1/order', types.PAY_SUCCESS, 'post'),
  [types.GET_ITEM]: makeAsyncRestfulAction('/api/v1/:model/:id'),
  [types.GET_ITEMS]: makeAsyncRestfulAction('/tdd/api/v1/:model'),
  [types.GET_ITEMS_V2]: makeAsyncRestfulAction('/api/v2/:model'),
  // 红包充值 
  [types.APPLY_REDBAG]: makeAsyncAction('/shop/api/redBag/apply', null, "post"),
  [types.GET_REDBAG_RECORDS]: makeAsyncRestfulAction('/shop/api/shopflowwater/list'),
  // 发起订单 升级豪华版
  [types.APPLY_PRO]: makeAsyncAction('/api/v4/order', null, "post"),

  // 微信支付调用
  [types.INVOKE_WECHAT_PAY]({
    dispatch,
    commit
  }, payload) {
	console.log('微信支付调用')
    return new Promise(async (resolve, reject) => {
      try {
		console.log('payload.payArgs:', payload.payArgs)
        if (!payload.payArgs) {
          const json = await dispatch(types.PAY, payload)
          if (!json.payArgs /* 成功创建订单, 支付参数为空 */) {
            return reject(new Error('BLANK_PAY_ARGS'))
          }
        }
        WeixinJSBridge.invoke('getBrandWCPayRequest', Object.assign(payload.payArgs), res => {
		  console.log('----------------------:', res)
          const err_msg = res.errMsg || res.err_msg
          if (err_msg == "get_brand_wcpay_request:ok") {
            resolve({ code: 200, data: { msg: '支付成功' } })
          }
          else if (err_msg == "get_brand_wcpay_request:fail") reject('支付失败，请重新尝试！' /*微信支付出错信息 */)
          else reject()
        })
      } catch (msg) {
        console.log(msg, "进入这里")
        reject(msg)
      }
    })
  },
  [types.GET_WECHAT_SHARE]({ commit }, data) {
  },
  [types.GET_WECHAT_CONFIG]({ commit }, data) {
  },
  [types.UPLOAD_PIC]: makeAsyncAction('/tdd/api/v1/wechat/upload', null, "post"),
  [types.POST_SMS]: makeAsyncAction('/api/v1/sms/code/login' ,null,"post"),
  [types.LOGIN]: makeAsyncAction('/api/v1/user/login',null,'post'),
  //  二维码
  [types.GET_QUOTA_QR]: makeAsyncAction('/auth/api/v1/poster/invite/:identityId', null),
  [types.GET_LEAF_INFO]: makeAsyncRestfulAction('/api/v1/activity/1'),
  [types.GO_GET_LEAF]: makeAsyncAction('/api/v1/activityinternal', null, "post"),
  [types.UPDATE_AWARD]: makeAsyncRestfulAction('/api/v1/activityAward/:id', null, 'put'),
  // 商学院
  [types.GET_ALBUMS_LIST]: makeAsyncRestfulAction('/home/api/v1/albums'),
  [types.GET_ALBUMS_ITEMS]: makeAsyncRestfulAction('/home/api/v1/album/:lessonId'),
  [types.GET_LESSON_DETAIL]: makeAsyncRestfulAction('/home/api/v1/album/:albumId/lesson/:lessonId'),

  // 判断路径是否存在
  [types.GET_HAVE_PATH]: makeAsyncRestfulAction('/tdd/v1/wxConfig/have/havePathParameter', null, 'get'),
  // 授权后给的id换取token
  [types.GET_USEINFO_GETONE]: makeAsyncAction('/tdd/v1/wechatofficialaccountuserinfo/getOne/:id', null, 'get'),
  // 使用token获取用户信息
  [types.GET_USE_GETONE]: makeAsyncAction('/tdd/v1/wechatofficialaccountuserinfo/getOne', null, 'get'),
  // 授权盟主
  [types.PUT_ALLIANCE_AUTH]: makeAsyncRestfulAction('/tdd/api/allianceactivityinfo/updateForSponsor', null, 'put'),
  // 我的店铺主页数据
  [types.GET_SHOP_ONE]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/getShopOne', null, 'get'),
  // 申请加入联盟
  [types.POST_JOIN_ALLIANCE]: makeAsyncRestfulAction('/tdd/api/v1/wechat/joinAlliance', null, 'post'),
  // 我的联盟数据
  [types.GET_ALLIANCE_ONE]: makeAsyncRestfulAction('/tdd/api/allianceactivityinfo/getById/:id', null, 'get'),
  // 商家信息
  [types.GET_CTIVITY_LIST]: makeAsyncRestfulAction('/tdd/api/allianceactivityalliance/getList', null, 'get'),
  // 申请列表
  [types.GET_APPLY_LIST]: makeAsyncRestfulAction('/tdd/api/allianceactivityalliance/getApplyList', null, 'get'),
  // 入盟申请
  [types.GET_ALLIANCE_GETONE]: makeAsyncRestfulAction('/tdd/api/allianceactivityalliance/getOne/:id', null, 'get'),
  // 申请状态
  [types.PUT_ALLIANCE_GETONE]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/update', null, 'put'),
  // 核销录入
  [types.GET_SHOP_GETLIST]: makeAsyncRestfulAction('/tdd/api/allianceactivityorderinfo/shopGetList', null, 'get'),
  // 录入数据
  [types.GET_DERINFO_GETONE]: makeAsyncRestfulAction('/tdd/v1/allianceactivityorderinfo/getOne/:id', null, 'get'),
  // 确定录入
  [types.PUT_DERINFO_LOGGIN]: makeAsyncRestfulAction('/tdd/api/allianceactivityorderinfo/loggingData', null, 'put'),
  // 获取联盟信息
  [types.GET_ALLIANCE_ACTIVITY]: makeAsyncRestfulAction('/tdd/v1/allianceactivityinfo/getOne/:id', null, 'get'),
  // 判断用户是否购买过礼包
  [types.GET_HAVE_ORDER]: makeAsyncRestfulAction('/tdd/api/allianceactivitygiftbagorderinfo/haveOrder', null, 'get'),
  // 获取联盟优惠券
  [types.GET_COUPON_LISTALL]: makeAsyncRestfulAction('/tdd/api/allianceactivitycoupon/getListAll', null, 'get'),
  // 获取领取的优惠券
  [types.GET_COUPONUSER_LISTALL]: makeAsyncRestfulAction('/tdd/api/allianceactivityusercoupon/getListByUser', null, 'get'),
  // 获取二维码
  [types.GET_USER_COUPONQR]: makeAsyncRestfulAction('/tdd/api/allianceactivityusercoupon/getUserCouponQr', null, 'get'),
  // 确认核销
  [types.PUT_SCAN_QRCONFIRM]: makeAsyncRestfulAction('/tdd/api/allianceactivityusercoupon/scanQrConfirm', null, 'get'),
  // 修改联盟状态
  [types.PUT_ALLIANCE_STATTUS]: makeAsyncRestfulAction('/tdd/api/allianceactivityinfo/status', null, 'put'),
  // 有无扫码权限
  [types.GET_SCANQR_PERMISSION]: makeAsyncRestfulAction('/tdd/api/allianceactivityusercoupon/scanQrPermission', null, 'get'),
  // 再次加入联盟
  [types.PUT_AGAIN_APPLICATION]: makeAsyncRestfulAction('/tdd/api/v1/wechat/againApplication', null, 'put'),
  // 商家获益详情
  [types.GET_EARNING_LIST]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/shopEarningsRankingList', null, 'get'),
  // 商家贡献详情
  [types.GET_RANKING_LIST]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/shopPayOutRankingList', null, 'get'),
  // 盟主分红详情
  [types.GET_MASTER_LIST]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/masterEarningsRankingList', null, 'get'),
  // 店铺获益明细
  [types.GET_SHOPONE_LIST]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/getShopOneEarnings', null, 'get'),
  // 店铺贡献明细
  [types.GET_SHOPONE_CONTRIBUTOR]: makeAsyncRestfulAction('/tdd/v1/allianceactivityalliance/getShopOneContributor', null, 'get'),
  // 佣金结算支付情况
  [types.GET_SHOP_PAYLIST]: makeAsyncRestfulAction('/tdd/api/allianceactivityorderinfo/shopPayList', null, 'get'),
  // 佣金结算收款情况
  [types.GET_SHOP_INCOMELIST]: makeAsyncRestfulAction('/tdd/api/allianceactivityorderinfo/shopIncomeList', null, 'get'),
  // 佣金结算确定收款
  [types.PUT_UPDATE_STATUS]: makeAsyncRestfulAction('/tdd/api/allianceactivityorderinfo/updateReturnStatus', null, 'put'),
  // 查询是否是盟主
  [types.GET_INFO_ISSPONSOR]: makeAsyncRestfulAction('/tdd/api/allianceactivityinfo/isSponsor', null, 'get'),
  // 首页请求
  [types.GET_ALLIANCEACTIVITY_INIT]: makeAsyncRestfulAction('/tdd/api/allianceactivityalliance/init', null, 'get'),

  //用户购买礼包
  [types.TO_BUY_GIFT_PACKGE]: makeAsyncRestfulAction('/tdd/api/allianceactivitygiftbagorderinfo/pay', null, 'post'),
  // 获取商品详情
  [types.GET_GOODS_DETAIL]: makeAsyncRestfulAction('/tdd/v1/product/getDetail/:id', null, 'get'),
  // H5 获取页面装修
  [types.GET_H5DETAIL_PAGE]: makeAsyncAction('/home/api/attractivepage/preview/:id', null, 'get'),
  // H5 提交表单
  [types.POST_H5FORM_CREATE]: makeAsyncRestfulAction('/home/api/formcontentapply/h5Create', null, 'post'),
  // H5 获取scheme码
  [types.POST_SCHEME_CODE]: makeAsyncRestfulAction('/auth/v1/mini/generatescheme', null, 'post'),
}